var HabitatVocab = {
  BRAND_NAME: 'Habitat',
  ADD_TO_TROLLEY: 'Add to bag',
  ITEM_CONTAINER: 'bag',
  CREDIT_URL: '/help/argos-card'
};
export default HabitatVocab;